<script setup>
import NavDrawer from "./NavigationDrawer.vue";
import Logo from "./ListItemLogo.vue";
import { useConfig } from "@/plugins/obscore.js";

const config = useConfig()
let expandedLogos=false

</script>
<template>
  <NavDrawer @hovering="(isHovering) => {expandedLogos = isHovering}">
    <template v-slot:header>
      <Logo v-bind="config.logo" :expanded="expandedLogos" />
      <v-divider class="my-2"></v-divider>
    </template>
    <template v-slot:footer>
      <v-divider class="mb-2 mt-auto"></v-divider>
      <Logo v-bind="config.sidebar.footer.logo" :expanded="expandedLogos">
        <v-list-item-title>version {{ config.sidebar.footer.version }} <br /> build {{ config.sidebar.footer.build }}</v-list-item-title>
      </Logo>
    </template>
  </NavDrawer>
</template>